import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { RequirePermission } from "@/libs/guard/admin-permission-guard";

// Subjects
const SubjectListPage = lazy(
  () => import("@quest/shared/subject/pages/subject-list")
);
const CreateSubjectPage = lazy(
  () => import("@quest/shared/subject/pages/create-subject")
);

const BulkImportSubjectPage = lazy(
  () => import("@quest/shared/subject/pages/bulk-import-subject")
);

const SubjectsImportFilesListPage = lazy(
  () => import("@quest/shared/subject/pages/subjects-import-files-list")
);

const SubjectsImportErrorDetailsPage = lazy(
  () => import("@quest/shared/subject/pages/subjects-import-error-details")
);

export const subjectsRoutes: RouteObject[] = [
  {
    path: "/admin/subjects",
    element: (
      <RequirePermission resource="subjects">
        <SubjectListPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/subjects/create",
    element: (
      <RequirePermission resource="subjects">
        <CreateSubjectPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/subjects/bulk-import",
    element: (
      <RequirePermission resource="subjects">
        <BulkImportSubjectPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/subjects/import-files-list",
    element: (
      <RequirePermission resource="subjects">
        <SubjectsImportFilesListPage />
      </RequirePermission>
    ),
  },
  {
    path: "/admin/subjects/import-error-details/:importId",
    element: (
      <RequirePermission resource="subjects">
        <SubjectsImportErrorDetailsPage />
      </RequirePermission>
    ),
  },
];
